import { render, staticRenderFns } from "./SmartCatAttachment.vue?vue&type=template&id=b7f8fb36"
import script from "./SmartCatAttachment.vue?vue&type=script&lang=js"
export * from "./SmartCatAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports